  <template lang="html">
  <div
    v-if="isShowQuesMenu"
    class="questionmenu"
  >
    <div :class="['questionmenu__main', { 'questionmenu__main--wl': isWonderland }]">
      <div :class="genBarCSS()">
        <Button
          type=icon
          :class="genLeftCSS()"
          :disabled="!canLeft"
          @click="handleLeft"
        >
          <div 
            :class='getBtnCss()' class='questionmenu__main__btn_left'>
            <i
            :class="canLeft
              ? `tz-icon-left-enable-${iconType}`
              : `tz-icon-left-disable-${iconType}`"
          />
            <span 
            :class="canLeft ? `tz-text-enable-${iconType}`
            : `tz-text-disable-${iconType}`"
            >
            上一题
            </span>
          </div>
         
        </Button>
        <div
          class="questionmenu__main-bar-label"
          @click="togglePan"
        >
          <div class="bar-con">
            <span
              v-if="role === 'teacher'"
              :class="[
                'bar-con__babel',
                `bar-con__${iconType}`
              ]"
            >
              {{ currentPracticeType }}
            </span>
            <div class="bar-con__num">
              <span class="molecular">{{current + 1}}</span>
              <span>/</span>
              <span class="denominator">{{list.length}}</span>
            </div>
            <span
              :class="[
                'bar-con__title',
                `bar-con__title-${role}`
              ]"
            >
              {{ currentTitle }}
            </span>
            <!-- <span
              v-show="iconType === 'sa'"
              type=icon
              @click.stop="$emit('modify-title')"
            >
              <i class="tz-icon-editor-sa"/>
            </span> -->
          </div>
        </div>
        <Button
          type=icon
          :class="genRightCSS()"
          :disabled="!canRight"
          @click="handleRight"
        >
        <div :class='getBtnCss()' class='questionmenu__main__btn_right'>
          <span :class="canRight ? `tz-text-enable-${iconType}`
            : `tz-text-disable-${iconType}`">
            下一题
          </span>
           <i
            :class="canRight
            ? `tz-icon-right-enable-${iconType}`
            : `tz-icon-right-disable-${iconType}`"
          />
        </div>
         
          
        </Button>
      </div>
      <!-- <div
        v-show="isShowPan"
        class="questionmenu__main-pan"
      >
        <i class="questionmenu__main-pan-arrow"></i>
        <ul class="questionmenu__main-pan-list">
          <li
            v-for="(item, index) in list"
            :key="`${item.category}${item.projectId}${index}`"
            :class="genItemCSS(item, list[index - 1])"
            @click="handleClick(index, item, list[index - 1])"
          >
            {{index + 1}}
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script type="text/babel">
import { MessageBox } from 'element-ui';
import { genResult } from '@/utils/questionsStrategy';
import { setClickBuryingPoint, setViewBuryingPoint } from '@/utils/buryingPoint';
import Button from '@/components/Button.vue';

export default {
  name: 'QuestionMenu',

  props: {
    bundle: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
    role: {
      type: String,
      default: 'student',
    },
    needLock: {
      type: Boolean,
      default: false,
    },
    needCorrect: {
      type: Boolean,
      default: false,
    },
    forceRender: {
      type: Number,
      default: 0,
    },
    buryingPointData: {
      type: Object,
    },
    practiceType: Number,
    isShowQuesMenu: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isShowPan: false,
      canLeft: true,
      canRight: true,
      iconType: null,
    };
  },

  components: {
    Button,
  },

  computed: {
    currentParams() {
      return {
        current: this.current,
        list: this.list,
      };
    },
    OptionalMessage() {
      if (this.role === 'student') {
        return '';
      }
      return `(${this.list[this.current].isOptional ? '选做' : '必做'})`;
    },
    list() {
      return genResult(this.bundle);
    },
    currentPracticeType() {
      const typeList = ['例', '中', '后', '考'];
      return typeList[this.practiceType - 1];
    },
    currentTitle() {
      const otherTitles = ['知识小挑战', 'CM编程挑战'];
      const { current, list } = this.currentParams;
      const { category, practiceName } = list[current];
      if (category === 1) {
        return otherTitles[1];
      }
      if (category === 2) {
        return practiceName;
      }
      if (category === 5 || category === 6) {
        return otherTitles[0];
      }
      return practiceName;
    },
    sendData() {
      return {
        canLeft: this.canLeft,
        canRight: this.canRight,
        role: this.role,
        currentPracticeType: this.currentPracticeType,
        currentTitle: this.currentTitle,
        current: this.current,
        // length: this.showOptional ? this.list.length : this.mustDoList.length,
        length: this.list.length,
        hasMustDo: this.hasMustDo,
        mustDoList: [],
        needCorrect: this.needCorrect,
        needLock: this.needLock,
        // showDivide: this.showOptional && this.hasOptional && this.hasMustDo,
        // showOptional: this.showOptional && this.hasOptional,
        showDivide: true,
        showOptional: true,
        optionalList: [],
        list: this.list,
      };
    },
    isWonderland() {
      return this.bundle && this.bundle[this.current] && this.bundle[this.current].pythonType === 13
    }
  },

  watch: {
    currentParams: {
      handler() {
        this.$forceUpdate();
      },
      immediate: false,
    },
    current: {
      handler() {
        if (this.currentParams.list[this.currentParams.current].isOptional === 1 && this.role === 'student') {
          setViewBuryingPoint(this, '156-2185', {}, this.buryingPointData);
          MessageBox.confirm('恭喜解锁挑战题，准备好挑战了吗？', '挑战题', {
            confirmButtonText: '挑战',
            cancelButtonText: '不了',
            customClass: 'OptionalDialog',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            center: true,
          }).then(() => {
            // 点击挑战按钮埋点
            setClickBuryingPoint(this, '156-2183', {}, this.buryingPointData);
          }).catch(() => {
            this.handleLeft();
            // 点击不了按钮埋点
            setClickBuryingPoint(this, '156-2184', {}, this.buryingPointData);
          });
        }
      },
      immediate: true,
    },
    forceRender() {
      this.$forceUpdate();
    },
    sendData(newVal) {
      this.sendMessage({ type: 'change', data: newVal });
    },
  },

  methods: {
    sendMessage(payload) {
      if (window.frames && window.frames.length > 0) {
        const obj = JSON.stringify({
          type: 'XH_SHARE_MENU_STATUS',
          payload,
        });
        Array.from(window.frames).forEach((frame) => frame.postMessage(obj, '*'));
      }
    },
    receiveMessage(evt) {
      try {
        const { type, payload } = JSON.parse(evt.data);
        if (type === 'XH_CHANGE_MENU_STATUS') {
          if (payload.type === 'loaded') {
            this.sendMessage({ type: 'change', data: this.sendData });
          }
          if (payload.type === 'function') {
            this[payload.name](...payload.data);
          }
        }
        if (type === 'XH_SUPER_CLICK_BACK') {
          this.$router.push(this.$route.query.back);
          this.$vmLoading.hide()
        }
      } catch (err) {
        // console.log(err);
      }
    },
    getBtnCss(){
      const arr = ['questionmenu__main__btn'];
      if (this.list[this.current]
      && (this.list[this.current].category === 2
      || this.list[this.current].category === 7)) {
        arr.push('questionmenu__main__btn-sa');
      } else {
        arr.push('questionmenu__main__btn-other');
      }
      return arr;
    },
    genBarCSS() {
      const arr = ['questionmenu__main-bar'];
      if (this.list[this.current]
      && (this.list[this.current].category === 2
      || this.list[this.current].category === 7)) {
        arr.push('questionmenu__main-bar-sa');
        this.iconType = 'sa';
      } else {
        arr.push('questionmenu__main-bar-other');
        this.iconType = 'others';
      }
      return arr;
    },
    genLeftCSS() {
      const arr = ['questionmenu__main-bar-left'];
      if (this.current > 0) {
        this.canLeft = true;
      } else {
        this.canLeft = false;
      }
      return arr;
    },
    handleLeft() {
      if (this.canLeft) {
        this.$emit('selectIndex', { index: this.current - 1, from: 'left' });
      }
    },
    genRightCSS() {
      const arr = ['questionmenu__main-bar-right'];
      if (this.list[this.current + 1] && (this.list[this.current].finish || !this.needLock)) {
        this.canRight = true;
      } else {
        this.canRight = false;
      }
      return arr;
    },
    handleRight() {
      if (this.canRight) {
        this.$emit('selectIndex', { index: this.current + 1, from: 'right' });
      }
    },
    togglePan() {
      this.isShowPan = !this.isShowPan;
    },
    genItemCSS(item) {
      // if (this.role === 'teacher') return ['questionmenu__main-pan-item', 'questionmenu__main-pan-item-green'];
      // const arr = ['questionmenu__main-pan-item'];
      // const classNameMap = {
      //   white: 'questionmenu__main-pan-item-white',
      //   yellow: 'questionmenu__main-pan-item-yellow',
      //   green: 'questionmenu__main-pan-item-green',
      // };
      // const isShowCorrect = this.needCorrect && (item.category === 5 || item.category === 6);
      // // eslint-disable-next-line max-len
      // const actions = [...QuestionStrategy].filter(([key]) => (key.category === item.category && key.status.includes(item.result)));
      // if (this.needLock) {
      //   actions.forEach(([key, value]) => {
      //     arr.push(classNameMap[value()]);
      //     if (pre && !key.finish && !pre.finish) arr.splice(-1, 1, 'questionmenu__main-pan-item-lock');
      //   });
      // } else {
      //   // eslint-disable-next-line no-unused-vars
      //   actions.forEach(([key, value]) => arr.push(classNameMap[value()]));
      //   // (考试/课后)客观题不展示对错
      //   if (isShowCorrect && arr[arr.length - 1] === 'questionmenu__main-pan-item-yellow') arr.splice(-1, 1, 'questionmenu__main-pan-item-green');
      // }
      // if (item.isOptional) {
      //   arr.push('questionmenu__main-pan-item-optional');
      // }
      // return arr;
      const arr = ['questionmenu__main-pan-item'];
      if (this.role === 'student') {
        if (item.finish) {
            arr.push('questionmenu__main-pan-item-green');
        } else {
          arr.push('questionmenu__main-pan-item-white');
        }
      } 
      return arr;
    },
    handleClick(index, item, pre) {
      if (!item.finish && pre && !pre.finish && this.needLock) {
        return;
      }

      this.$emit('selectIndex', { index, from: 'item' });
    },
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "~@/assets/less/mixin.less";

@green-color: #AFD263;
@dark-green: #50731B;
@light-green: #8FBA50;

@sa-primary-color: @green-color;
@sa-background-color: #578A29;
@sa-border-color: #517915;

@brown-color: #B6885B;
@dark-brown: #432B22;
@light-brown: #A27143;

@others-primary-color: @brown-color;

.questionmenu {
  &__main {
    &-bar {
      border-radius: 4px;
      &-label {
        display: inline-block;
        width: 168px;
        vertical-align: top;
        cursor: pointer;
        .bar-con {
          background: #4E3930;
          border: 1px dashed #7E5644;
          border-radius: 4px;
          padding: 0 8px;
          font-weight: 500;

          display: flex;
          justify-content: space-between;
          align-items: center;

          &__babel {
            width: 20px;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            text-align: center;
            border-radius: 50%;
            background: red;
            margin-right: 6px;
          }

          &__num {
            .molecular{
              font-size: 16px;
            }
            .denominator {
              font-size: 12px;
            }
            margin-right: 5px;
          }
          &__title {
            max-width: 85px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            flex: 1;
            &-student {
              max-width: 140px !important;
            }
          }

        }
      }
    }
    &-bar-sa {
      height: 35px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .questionmenu__main-bar-label {
        width: 197px;
        color: @sa-primary-color;
        line-height: 35px;
        margin: 0 10px;
        .bar-con {
          background: @sa-background-color;
          border: 1px dashed @sa-border-color;
          border-radius: 4px;
          &__babel {
            background: #4D7019;
          }
          &__title {
            max-width: 100px;
          }
        }
      }
    }
    &-bar-other {
      height: 35px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .questionmenu__main-bar-label {
        width: 197px;
        color: @others-primary-color;
        line-height: 35px;
        margin: 0 10px;
        .bar-con {
          color: #B6885B;
          &__babel {
            background: #2D1E18;
          }
          &__title {
            max-width: 115px;
          }
        }
      }
    }
    &-pan {
      position: absolute;
      top: 50px;
      border: 1px solid #d5d2bc;
      border-radius: 4px;
      &-arrow {
        position: absolute;
        top: -15px;
        left: 50%;
        display: block;
        width: 20px;
        height: 20px;
        background-color: #f8f6e6;
        border: 1px solid #d5d2bc;
        transform: translate(-10px, 5px) rotate(45deg);
        z-index: 0;
      }
      &-list {
        list-style: none;
        margin: 0;
        padding: 0 12px 7px;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        width: 266px;
        background-color: #f8f6e6;
        border-radius: 4px;
        z-index: 1;
      }
      &-item {
        margin: 7px 5px 0;
        display: inline-block;
        width: 27px;
        height: 27px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
      }
      &-item-green {
        border: 1px solid #6b8636;
        background-color: #b0c265;
        cursor: pointer;
        &:hover {
          background-color: #9aae4a;
        }
      }
      &-item-yellow {
        border: 1px solid #c7b990;
        background-color: #dfd2a9;
        cursor: pointer;
        &:hover {
          background-color: #d1c18f;
        }
      }
      &-item-white {
        border: 1px solid #d5d2bc;
        background-color: #fff;
        cursor: pointer;
      }
      &-item-lock {
        font-size: 0;
        border: 1px solid #878786;
        background-color: #9b9b9b;
        .bg-img('~@/assets/images/lock');
        background-repeat: no-repeat;
        background-size: 12px 16px;
        background-position: center;
        cursor: not-allowed;
      }
    }
    &__btn{
      width: 80px;
      height: 24px;
      display: flex;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      border-radius: 12px;
      font-size: 14px;
      &_left{
        padding:0 10px 0 2px;
      }
      &_right{
        padding:0 2px 0 10px;
      }
      &-other{
        background: #B6885B;
      }
      &-sa{
        background: #AFD263;
      }
    }
  }

  &__main--wl {
    margin-right: 24px;
    ::v-deep .x-button--disabled {
      opacity: 0.4;
    }
    .questionmenu__main__btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 36px;
      padding: 0;
      border-radius: 18px;
      background: transparent;
      border: 3px solid #D0CED3;

      i {
        display: none;
      }
    
      span {
        color: #fff;
      }
    }

    .bar-con {
      background: #35333A;
      border: 0;
      border-radius: 2px;
      transform: skew(-10deg);
      .bar-con__num,
      .bar-con__title {
        color: rgba(255, 255, 255, .8);
        transform: skew(10deg);
      }
      .bar-con__num {
        margin-left: 6px;
      }
    }
  }
}
</style>

<style lang="less">
.OptionalDialog {
  padding-bottom: 28px;
  .el-message-box__header {
    padding-top: 25px;
    font-size:20px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,1);
    line-height:28px;
    letter-spacing:1px;
  }
  .el-message-box__content {
    padding-top: 21px;
    padding-bottom: 30px;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(20,20,20,1);
    line-height:22px;
  }
  .el-message-box__btns{
    padding: 0px 80px;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    line-height:22px;
    display: flex;
    justify-content: space-between;
    .el-button--default{
      width:110px;
      height:38px;
      background:rgba(255,247,231,1);
      border-radius:19px;
      border:2px solid rgba(252,235,203,1);
      color:rgba(107,76,46,1);
    }
    .el-button--default.el-button--primary {
      width:110px;
      height:38px;
      background:rgba(104,149,60,1);
      border-radius:19px;
      border:2px solid rgba(75,118,53,1);


      color:rgba(246,242,218,1);

    }
  }
}
</style>
